<template>
  <div :class="{animate__heartBeat: playing}"
       class="icon animate__faster animate__repeat"
       @click="toggle">
    <svg id='pause' width="30" height="30">
      <circle id="circle" cx="15" cy="15" r="14.5" stroke-dasharray="314"
              stroke-dashoffset="0"
              :class="{play: !playing}"
              class="stroke"
              style="
                stroke-width:1px;
                stroke:#b8b8b8;
                overflow: hidden
              "
      />
      <line id='line1' x1="11" y1="10" x2="11" y2="20"
            style="stroke-width:1px;stroke:#b8b8b8;stroke-linecap: round;"/>
      <path id='line2' d="M 19 20 L 19 11 L 19 10" rx="10" ry="10"
            style="stroke-width:1px;
            stroke:#b8b8b8;
            fill: transparent;
            stroke-linejoin: round;
            stroke-linecap: round;"
      >
        <animate
          attributeName="d"
          dur="300ms"
          from="M 19 20 L 19 11 L 19 10"
          to="M 11 20 L 19 15 L 11 10"
          begin="indefinite"
          fill="freeze"
          id="from_pause_to_play"
        />
      </path>
      <animate
        xlink:href="#line2"
        attributeName="d"
        dur="300ms"
        from="M 11 20 L 19 15 L 11 10"
        to="M 19 20 L 19 12 L 19 10"
        fill="freeze"
        id="from_play_to_pause"
        begin="indefinite"
      />
    </svg>
  </div>
</template>

<script>
import 'animate.css';
import Audio from '@/audio-bus';

const { AudioBus, Playlist } = Audio;

export default {
  name: 'PlayPauseIcon.vue',
  props: {
    border: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    playing() {
      return AudioBus.playing;
    },
  },
  data() {
    return {
      audio: null,
    };
  },
  methods: {
    toggle() {
      if (this.playing) {
        Playlist.pause();
      } else {
        Playlist.play(this.$data.audio);
      }
    },
    toPlay(name) {
      document.getElementById('from_pause_to_play').beginElement();
      this.audio = name;
    },
    toPause() {
      document.getElementById('from_play_to_pause').beginElement();
    },
  },
  mounted() {
    this.toPlay();
    AudioBus.$on('play', this.toPause);
    AudioBus.$on(['pause', 'end'], this.toPlay);
  },
};
</script>

<style scoped>
  .icon {
    display: inline-block;
    cursor: pointer;
    --animate-repeat: 100;
  }

  .circle {
    stroke-width: 1px;
    stroke: #b8b8b8;
    overflow: hidden
  }

  #circle {
    transition: stroke-dashoffset 300ms ease-in;
    stroke-dashoffset: 0;
    fill: none;
  }
</style>
